var configuredBaseUrl = process.env.REACT_APP_BASE_URL || '';
/**
 * Base URL of the backend API.
 *
 * Staging/production configure an ABSOLUTE url (e.g. "https://api-dev.idcerberus.com/api"). That
 * matters: the service layer builds request urls as `${BASE_URL}/...` and passes them to an axios
 * instance whose `baseURL` is also BASE_URL — axios only skips `baseURL` when the url is absolute.
 *
 * The idCerberus Small Edition (On-Premise) serves the SDK from the backend itself, so the API is
 * on the same origin and is configured RELATIVELY as "/api". Left as-is, axios would prefix it and
 * request "/api/api/...". Resolving a relative value against the current origin keeps the url
 * absolute, so the same-origin setup works and absolute (staging/production) values are untouched.
 */
export var BASE_URL = configuredBaseUrl.startsWith('/') && typeof window !== 'undefined' && window.location
    ? "".concat(window.location.origin).concat(configuredBaseUrl)
    : configuredBaseUrl;
